export const SLIDE_MENU_PREFIX = "SlideMenu";

export const SLIDE_MENU_CLASSES = {
  drawer: `${SLIDE_MENU_PREFIX}-drawer`,
};
